import { Button } from "@minuthq/meatball-ui-react"
import { differenceInDays } from "date-fns"

import { AppStoreLogos } from "src/components/EmptyState/AppStoreLogos"
import { EmptyStateWithImage } from "src/components/EmptyState/EmptyStateWithImage"
import { IGraphDateRange } from "src/components/Homes/DeviceDetails/Overview/DeviceGraphs"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { useRouter } from "src/router/useRouter"
import { spacing } from "src/ui/spacing"

import Desktop from "./images/noise-insight-no-events.svg"
import Mobile from "./images/noise-insight-no-events-mobile.svg"
import NoiseInsightsEmptyStateImage from "./images/noise-insights-graph-empty-state.svg"
import UnmonitoredHomesImage from "./images/noise-insights-no-monitored-homes.svg"

export function NoNoiseInsightsNoDevices() {
  const { t, langKeys } = useTranslate()

  return (
    <EmptyStateWithImage
      Image={NoiseInsightsEmptyStateImage}
      title={t(langKeys.noise_insight_no_installed_devices_title)}
      description={t(langKeys.noise_insight_no_installed_devices_subtitle)}
      content={<AppStoreLogos />}
      imageSpacing={spacing.M}
    />
  )
}

export function NoNoiseInsightsNoEvents({
  dateRange,
}: {
  dateRange: IGraphDateRange
}) {
  const { t, langKeys } = useTranslate()

  const daysInRange = differenceInDays(dateRange.endDate, dateRange.startDate)

  return (
    <EmptyStateWithImage
      Image={Desktop}
      MobileImage={Mobile}
      title={t(langKeys.noise_insight_no_events_title, {
        daysInRange,
      })}
      description={t(langKeys.noise_insight_no_events_subtitle, {
        daysInRange,
      })}
      imageSpacing={spacing.M}
      limitImageWidth={false}
    />
  )
}

export function NoNoiseInsightsNoMonitoredHomes() {
  const { t, langKeys } = useTranslate()
  const { navigate } = useRouter()

  return (
    <EmptyStateWithImage
      Image={UnmonitoredHomesImage}
      title={t(langKeys.noise_insight_all_units_unmonitored_title)}
      description={t(langKeys.noise_insight_all_units_unmonitored_subtitle)}
      content={
        <>
          <Button
            onClick={() =>
              navigate(
                Routes.Homes.location({
                  offline_sensors: "any",
                })
              )
            }
          >
            {t(langKeys.noise_insight_all_units_unmonitored_button)}
          </Button>
        </>
      }
      imageSpacing={spacing.M}
    />
  )
}

export function NoNoiseInsightsNoHomesInHomegroup() {
  const { t, langKeys } = useTranslate()
  const { navigate } = useRouter()

  return (
    <EmptyStateWithImage
      Image={NoiseInsightsEmptyStateImage}
      title={t(langKeys.noise_insight_no_units_in_homegroup_title)}
      description={t(langKeys.noise_insight_no_units_in_homegroup_subtitle)}
      content={
        <>
          <Button onClick={() => navigate(Routes.Homes.location())}>
            {t(langKeys.noise_insight_no_units_in_homegroup_button)}
          </Button>
        </>
      }
      imageSpacing={spacing.M}
    />
  )
}
